import HttpService from "./HttpService";

let cadernoService = {

    buscarListaDeCadernos: () => {
        return HttpService.backApi.get('/cadernos/list');
    },

    buscarCaderno: (id) => {
        return HttpService.backApi.get(`/cadernos/${id}`)
    },

    salvarCaderno: (caderno) => {
        return HttpService.backApi.post("/cadernos/create", caderno)
    },

    atualizarCaderno: (caderno) => {
        return HttpService.backApi.put("/cadernos", caderno)
    },

    deletarCaderno: (id) => {
        return HttpService.backApi.delete(`/cadernos/${id}`)
    }

};

export default cadernoService;
